import API from '../../../../../services/api';

export const API_INCIDENCIAS_STEPS = {
    getIncidenciaSteps: async (incidenciaId) => {
        const tipo = incidenciaId ? '?tipo_incidencia_id=' + incidenciaId : '';
        return API.get('/incidencia_steps' + tipo).then(res => res.data);
    },
    newStep: async (step) => {
        return API.post('/incidencia_steps', step).then(res => res.data);
    },
    updateStep: async (step) => {
        return API.put('/incidencia_steps/' + step.id, step)
            .then(res => res.data)
            .catch(error => error.response.data.message);
    },
    deleteStep: async (stepId) => {
        return API.delete('/incidencia_steps/' + stepId).then(res => res.data);
    }
}